import { Payment as ReturnType } from "Types/Reducers";
import { payment as actions } from "actions";
import { payment as statuses } from "globalConstants";

const initialState = {
   type: statuses.card,
};

function payment(state = initialState, { type, payload }: { type: typeof actions[keyof typeof actions]; payload: any }): ReturnType {
   switch (type) {
      case actions.setCard:
         return {
            ...state,
            type: statuses.card,
         };
      case actions.setPhone:
         return {
            ...state,
            type: statuses.phone,
         };
      case actions.setWithoutPassbook:
         return {
            ...state,
            type: statuses.withoutPassbook,
         };
      default:
         return state;
   }
}

export { actions };
export { statuses };
export { payment };
